<template>
    <div id="homback">
            <div class="logiokno">
                <img src="~@/assets/images/logo.png" alt="CMS" />
                <form>
                    <md-field>
                    <label>Prihlasovacie meno</label>
                    <md-input v-model="name" name="name" required @keyup.enter="login()"></md-input>
                    </md-field>
                    <md-field>
                        <label>Heslo</label>
                        <md-input v-model="password" type="password" name="password" required></md-input>
                    </md-field>
                    <md-button class="md-raised md-primary bau" v-on:click="login()"> <i class="fas fa-sign-in-alt"  ></i> Prihlásiť sa</md-button>

                </form>
            </div>
        <notifications group="err" position="top right" width="400"/>

    </div>

</template>

<script>

    export default {

        data() {
            return {
                    name: "",
                    password: ""
            }

        },
         methods: {
             login () {
              var self = this;
              var meno = this.name;
               var heslo = this.password;

               if(meno == '' || heslo == ''){
                   this.$notify({
                       group: 'err',
                       type: 'error',
                       title: '<i class="fas fa-exclamation-triangle"></i> Chyba',
                       text: 'Meno a heslo sú povinné',
                       duration: 1000,
                       speed: 1000
                   });
                 }else{
                   //
                   this.$http.post('//adminli.limousintravel.eu/api/login.php',  { username: this.name, password: this.password }).then(function (response) {
                        if(response.data == 'nie'){
                            self.$notify({
                                group: 'err',
                                type: 'error',
                                title: 'Chyba',
                                text: 'Meno a heslo sú nesprávne',
                                duration: 1000,
                                speed: 1000
                            });
                       }else{
                            if(response.data['id'] == '1'){
                                self.$localStorage.set("token", response.data['id']);
                                self.$localStorage.set("meno", response.data['user']);
                                self.$localStorage.set("lastlogin", response.data['lastlogin']);
                                self.$localStorage.set("lastlogine", response.data['lastlogine']);

                                self.$emit("authenticated", true);
                                self.$router.push({name:'dashboard'})

                            }else{
                                self.$notify({
                                    group: 'err',
                                    type: 'error',
                                    title: 'Chyba',
                                    text: 'Kontaktujte admina',
                                    duration: 1000,
                                    speed: 1000
                                });
                                console.log(response.data)
                            }
                       }

                   });
               }

            },


        }
    }
</script>

<style scoped lang="scss" >
#homback{
    background-image: url('~@/assets/images/1.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: fixed;
    width: 100%;
    height: 100%;
}
    .logiokno{
        position: relative;
        width: 95%;
        max-width: 400px;
        margin: 10% auto;
        background-color: rgba(255,255,255,.42);
        padding: 32px 20px 20px;
        border-radius: 10px;
        box-shadow: 0 0 5px #979494;

        input{
            border-bottom: 1px dotted #828282;
        }

        img{
            width: 100px;
            position: absolute;
            top: -122px;
            right: 50%;
            margin-right: -50px;
        }
        .bau{
            background-color: #4CAF50 !important;
            width: 100%;
        }
    }




</style>